module.exports = __webpack_public_path__ + "img/arrow-next-lg.f0e06140.svg";